/**
 * 인증 서비스
 * 관리자 로그인, 로그아웃, 현재 사용자 정보 조회 기능을 제공합니다.
 */

import { apiRequest, setToken, removeToken, getToken } from './apiClient';
import type { ApiResponse, LoginRequest, LoginResponse, AdminUser } from './types';

/**
 * 로그인
 * @param credentials 이메일과 비밀번호
 * @returns 로그인 응답 (토큰, 사용자 정보)
 */
export async function login(credentials: LoginRequest): Promise<ApiResponse<LoginResponse>> {
  const response = await apiRequest<LoginResponse>('/api/admin/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });

  // 로그인 성공 시 토큰 저장
  if (response.success && response.data?.token) {
    setToken(response.data.token);
  }

  return response;
}

/**
 * 로그아웃
 * @returns 로그아웃 응답
 */
export async function logout(): Promise<ApiResponse<{ message: string }>> {
  const response = await apiRequest<{ message: string }>('/api/admin/logout', {
    method: 'POST',
  });

  // 로그아웃 시 토큰 삭제
  removeToken();

  return response;
}

/**
 * 현재 사용자 정보 조회
 * @returns 현재 로그인된 사용자 정보
 */
export async function getCurrentUser(): Promise<ApiResponse<{ user: AdminUser }>> {
  return apiRequest<{ user: AdminUser }>('/api/admin/me', {
    method: 'GET',
  });
}

/**
 * 인증 상태 확인
 * @returns 토큰 존재 여부
 */
export function isAuthenticated(): boolean {
  return !!getToken();
}

/**
 * 저장된 토큰 조회
 * @returns 저장된 인증 토큰
 */
export { getToken };
